import includes from 'lodash/includes';
/**
 * Converts a number representation of kilobytes to bytes
 */

export var kbToBytes = function kbToBytes(kilobytes) {
  return Math.floor(kilobytes * 1024);
};
/**
 * Converts a number representation of megabytes to bytes
 */

export var mbToBytes = function mbToBytes(megabytes) {
  return Math.floor(megabytes * 1048576);
};
/**
 * Accepts a file object and intended max size in bytes
 * @example
 * // isFileSizeValid(file, mbToBytes(2))
 */

export var isFileSizeValid = function isFileSizeValid(file, maxsize) {
  return file.size <= maxsize;
};
/**
 * Accepts a file object and a list of content-types (as strings)
 * @example
 * // isFileTypeValid(
 * //   file,
 * //   ['text/jpg', 'text/png']
 * // )
 */

export var isFileTypeValid = function isFileTypeValid(file, types) {
  return includes(types, file.type);
};
/**
 * Common content type constants below
 */

export var CONTENT_TYPE_JPG = 'image/jpeg';
export var CONTENT_TYPE_PJPG = 'image/pjpeg';
export var CONTENT_TYPE_PNG = 'image/png';
export var CONTENT_TYPE_GIF = 'image/gif';
export var CONTENT_TYPE_BMP = 'image/bmp';
export var IMAGE_CONTENT_TYPES = [CONTENT_TYPE_JPG, CONTENT_TYPE_PJPG, CONTENT_TYPE_PNG, CONTENT_TYPE_GIF, CONTENT_TYPE_BMP];